import { render, staticRenderFns } from "./CardBodyItemLink.vue?vue&type=template&id=22e61afe"
import script from "./CardBodyItemLink.vue?vue&type=script&lang=ts"
export * from "./CardBodyItemLink.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22e61afe')) {
      api.createRecord('22e61afe', component.options)
    } else {
      api.reload('22e61afe', component.options)
    }
    module.hot.accept("./CardBodyItemLink.vue?vue&type=template&id=22e61afe", function () {
      api.rerender('22e61afe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/card/CardBodyItemLink.vue"
export default component.exports